module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/458.463bddbd.png";